var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7451 2.44727L17.3779 1.79688C17.6768 1.48047 17.6768 1.05859 17.3779 0.768555L17.1758 0.557617C16.9033 0.285156 16.4727 0.320312 16.1826 0.601562L15.541 1.23438L16.7451 2.44727ZM6.17188 12.0361L7.88574 11.2891L16.0947 3.08887L14.8906 1.90234L6.69043 10.1025L5.89941 11.7549C5.8291 11.9043 6.00488 12.1064 6.17188 12.0361ZM2.97266 17.7314H13.291C14.873 17.7314 15.7871 16.8174 15.7871 15.0068V5.61133L14.3721 7.02637V14.9365C14.3721 15.8506 13.8799 16.3164 13.2734 16.3164H2.99902C2.12012 16.3164 1.62793 15.8506 1.62793 14.9365V4.96094C1.62793 4.04688 2.12012 3.57227 2.99902 3.57227H11.0059L12.4209 2.15723H2.97266C1.14453 2.15723 0.212891 3.07129 0.212891 4.88184V15.0068C0.212891 16.8262 1.14453 17.7314 2.97266 17.7314Z",
    fill: "#32D74B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.87d1af479a4f9d748e910f908601e688.svg";
export { ForwardRef as ReactComponent };